import React from "react";
import { useNavigate } from "react-router-dom";
import { FaPhone, FaSignInAlt, FaBars, FaTimes } from "react-icons/fa";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import "./Home.css";
import logo from "../assets/logoelite.jpeg";
import PrimeProgramme from "../assets/PrimeProgram.jpg";
import Techno from "../assets/Techno.jpg";

const Home = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = React.useState(false);

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleAboutClick = () => {
    navigate("/about");
  };

  return (
    <div>
      {/* Header */}
      <header className="header" style={{ position: "sticky", top: 0, zIndex: 90, height: 72, alignItems: "center", display: "flex" }}>
        <div className="logo-container">
          <img
            src={logo}
            alt="Elite Academy Logo"
            className="logo"
            style={{ width: 80,height:64, transformOrigin: "left center" }}
          />
           <span className="logo-text">Elite Academy</span>
         </div>

        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <button className="nav-btn-link" onClick={() => navigate("/")}>HOME</button>
          <button className="nav-btn-link" onClick={() => navigate("/about")}>ABOUT US</button>
          <button className="nav-btn-link" onClick={() => navigate("/features")}>FEATURES</button>
          <button className="nav-btn-link" onClick={() => navigate("/contact")}>CONTACT US</button>
        </nav>

        <div className="header-right">
        <button
            className="sample-btn"
            onClick={() => navigate("/sample-copy")}
            aria-label="View sample copies"
            style={{
              marginLeft: 12,
              background: "linear-gradient(90deg,#ff7a18,#af002d)",
              color: "#fff",
              border: "none",
              padding: "8px 14px",
              borderRadius: 8,
              boxShadow: "0 6px 18px rgba(175,0,45,0.18)",
              cursor: "pointer",
              fontWeight: 700,
              letterSpacing: 0.2,
            }}
          >
            Sample Copy
          </button>
          <button className="login-btn" onClick={handleLoginClick}>
             LOGIN
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <main className="hero-section">
        <div className="hero-content">
          <h1>Welcome to Elite Academy</h1>
          <p>Your trusted platform for learning and excellence.</p>
        </div>
      </main>

      {/* FIX: Wrap in a div with margin & full width */}
      <div style={{ width: "100%", padding: "20px 0", backgroundColor: "#fffde7" }}>
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#f57f17" }}
          >
            Our Programmes
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            {/* Prime Program */}
            <Grid item xs={12} sm={6} md={4}>
              <Card sx={{ maxWidth: 345, boxShadow: 3 }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={PrimeProgramme}
                  alt="Prime Program"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5">
                    Prime Programme
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Our flagship programme offering a comprehensive and in-depth learning experience.
                  </Typography>
                </CardContent>
                <CardActions>
              <Button size="small" variant="contained" color="primary" onClick={() => navigate("/prime")}>
                    Learn More
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            {/* Techno Unique Program */}
            <Grid item xs={12} sm={6} md={4}>
              <Card sx={{ maxWidth: 345, boxShadow: 3 }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={Techno}
                  alt="Techno Unique Program"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5">
                    Techno Unique Programme
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Blending technology with education for a futuristic learning approach.
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small" variant="contained" color="primary" onClick={() => navigate("/techno")}>
                    Learn More
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            {/* Olympiad Programme */}
            <Grid item xs={12} sm={6} md={4}>
              <Card sx={{ maxWidth: 345, boxShadow: 3 }}>
                <CardMedia
                  component="img"
                  height="200"
                  image="https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60"
                  alt="Olympiad Programme"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5">
                    Olympiad Programme
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Tailored for competitive exams, enhancing analytical and problem-solving skills.
                  </Typography>
                </CardContent>
                <CardActions>
                <Button size="small" variant="contained" color="primary" onClick={() => navigate("/olympiad")}>
                    Learn More
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Container>
        {/* Footer */}
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Elite Academy. All Rights Reserved.</p>
      </footer>
      </div>
    </div>
  );
};

export default Home;
